import { render, staticRenderFns } from "./brokerageEdit.vue?vue&type=template&id=90ef146e"
import script from "./brokerageEdit.vue?vue&type=script&lang=js"
export * from "./brokerageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports